module.exports = {
	"authentication": {
		"partner": {
			"text": "Er du medlem eller kunde hos en af vores samarbejdspartnere, så har du adgang til forskellige fordele.",
			"next": "Forsæt",
			"none": "Ingen partner",
			"back": "Tilbage"
		},
		"create": {
			"external": "Opret dig med",
			"back": "Gå tilbage",
			"button": "Opret bruger",
			"button_next": "Næste",
			"existing": "Allerede medlem?",
			"authenticate": "Log ind",
			"name": "Dit fulde navn",
			"phone": "Dit telefonnummer",
			"phone_hint": "Hvis vi får brug for at kontakte dig i forbindelse med dine juridiske dokumenter",
			"email": "Din email",
			"password": "Opret kodeord",
			"password_hint": "Dit kodeord skal være på min. 6 tegn og indeholde min. ét tal og ét bogstav",
			"conditions": "Jeg accepterer <a href=\"https://testaviva.dk/vilkaar\" target=\"_blank\">regler og betingelser</a>",
			"marketing": "Jeg giver samtykke til, at TestaViva kan kontakte mig pr. e-mail, SMS eller telefonisk angående fordelene ved TestaVivas juridiske dokumenter samt vejlede mig bedst muligt i denne forbindelse. Jeg er opmærksom på, at jeg til enhver tid kan trække mit samtykke tilbage på Min Profil på TestaViva.dk.",
			"validation": "Din bruger er blevet oprettet, men da du benytter en e-mail vi allerede kender, har vi sendt en e-mail til dig med et bekræftelselink du skal trykke på",
			"errors": {
				"empty": "Dette felt må ikke stå tomt",
				"empty_name": "Du skal angive dit fulde navn",
				"empty_phone": "Du skal angive dit telefonnummer",
				"empty_email": "Du skal angive din email",
				"name": "Du skal indtaste dit fornavn og efternavn",
				"phone": "Dit telefon nummer er ikke gyldigt",
				"email": "Din email er ikke gyldig",
				"conditions": "Du skal acceptere vores regler og betingelser",
				"unknown": "Der skete en ukendt fejl. Prøv venligst igen, eller kontakt TestaViva."
			}
		}
	}
};